export default __webpack_public_path__ + "static/header-marketing-27c29174399b5473f7db36abd4301acd.png";